// extracted by mini-css-extract-plugin
export var buttonClassName = "PricingSection-module--buttonClassName--cb1d5";
export var buttonsContainer = "PricingSection-module--buttonsContainer--78f2b";
export var contentTitle = "PricingSection-module--contentTitle--71549";
export var extraContent = "PricingSection-module--extraContent--017d9";
export var extraKicker = "PricingSection-module--extraKicker--e2b8e";
export var headingContainerStyling = "PricingSection-module--headingContainerStyling--0edf7";
export var newPriceCard = "PricingSection-module--newPriceCard--67534";
export var priceCard = "PricingSection-module--priceCard--b31b9";
export var priceCardBigger = "PricingSection-module--priceCardBigger--45214";
export var priceCardsContainer = "PricingSection-module--priceCardsContainer--a78f4";
export var priceContentCard = "PricingSection-module--priceContentCard--d9a5e";
export var priceSeparator = "PricingSection-module--priceSeparator--a49c6";
export var sectionContent = "PricingSection-module--sectionContent--cacab";
export var sectionFooter = "PricingSection-module--sectionFooter--62499";
export var sectionHeader = "PricingSection-module--sectionHeader--45efb";